import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Checkbox, Page, Tile} from '../../../shared';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import {_openModal} from '../../../shared/reducers/modals';
import {gatherData, getUpdatedFilter} from '../../../shared/utils/utils';
import DocumentVault from '../../../shared/pages/DocumentVault';
import DescriptiveText from '../../../shared/components/DescriptiveText';
import StickyHeaderBar from '../../shared/components/StickyHeaderBar';
import styled from 'styled-components/macro';

const gatherDocuments = gatherData('/documents');

const _Wrapper = styled.div`
  width: 100%;
`;

const Documents = props => {
  const {session, openModal} = props;
  const [filters, setFilters] = useState({});

  const dataManager = {
    gatherData: inputValue => gatherDocuments({
      ...getUpdatedFilter(filters),
      ...inputValue,
    }),
  };
  const updateFilter = (name, value) => {
    setFilters({
      ...filters,
      [name]: value,
    });

    dataManager.refresh();
  };

  const tableFilters = [
    <Checkbox
      key="new"
      title="New"
      dataPoint={{
        name: 'isNew',
        value: !!(filters.isNew),
      }}
      onChange={(name, value) => {
        updateFilter(name, !value ? null : 1);
      }}
      disabled={false}/>,
    <Checkbox
      key="uploadedByUser"
      title="Uploaded by Me"
      dataPoint={{
        name: 'ownerID',
        value: !!(filters.ownerID),
      }}
      onChange={(name, value) => {
        updateFilter(name, !value ? null : session.profile.id);
      }}
      disabled={false}/>,
  ];
  const tableIconsKey = [
    {
      title: 'New Content',
      image: 'dotNew',
      color: '#00D0BE',
      description: 'The content has newly been added to the library.',
      category: 'General',
      displayCondition: d => !!d.isNew,
    },
  ];

  const buttons = {
    primary: {
      label: 'Add Document',
      action: () => openModal({
        componentName: 'AddDocument',
        refreshPage: () => dataManager.refresh(),
        description: <DescriptiveText>
          Upload documents for safe keeping or to easily share
          with your {pluralize(session.profile.advisorTerm.toLowerCase())}.
        </DescriptiveText>,
      }),
    },
  };

  return (
    <Page>
      <_Wrapper>
        <StickyHeaderBar title={'DOCUMENT VAULT'} height={'50px'} buttons={buttons}/>
        <Tile key="Documents" title="All Documents">
          <DocumentVault openModal={openModal}
                         session={session}
                         dataManager={dataManager}
                         dataFilters={filters}
                         tableFilters={tableFilters}
                         tableIconKeys={tableIconsKey}
                         allowCreatorActions={true}/>
        </Tile>
      </_Wrapper>
    </Page>

  );
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Documents);

Documents.propTypes = {
  /**
   * Is Session Reducer
   */
  session: PropTypes.shape({
    runAsInvestor: PropTypes.number.isRequired,
    profile: PropTypes.shape({
      id: PropTypes.number.isRequired,
      advisorTerm: PropTypes.string,
      brand: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }).isRequired,
  /**
   * The open function that dispatches _openModal from Redux
   */
  openModal: PropTypes.func.isRequired,
};
